export default {
  lang: {
    reset: 'Réinitialisation',
    search: 'Filtrage',
    expand: 'Développez',
    collapse: 'Rranger',
  },
};
